import { useCallback } from 'react'
import { useSettingsStore } from '@/store/settingsStore'
import type { Copy } from './en'
import type { FormatVars } from './format'
import { format } from './format'
import type { LocaleCode, LocaleDescriptor } from './locales'
import { COPY, LOCALES } from './locales'

/**
 * Copy access.
 *
 * There is no context provider: the active locale lives in the settings store,
 * which is already the single source of truth for it. Adding a provider would
 * mean two places that could disagree about what language the app is in, and
 * the one thing this product cannot afford is being unsure which language it
 * is speaking.
 */

export function useLocale(): LocaleCode {
  return useSettingsStore((state) => state.locale)
}

export function useCopy(): Copy {
  return COPY[useSettingsStore((state) => state.locale)]
}

export function useLocaleDescriptor(): LocaleDescriptor {
  return LOCALES[useSettingsStore((state) => state.locale)]
}

/** Interpolates a template from the active locale. */
export function useFormat(): (template: string, vars?: FormatVars) => string {
  return useCallback((template: string, vars?: FormatVars) => format(template, vars), [])
}

/** Reads copy outside React, for the director and the transports. */
export function readCopy(): Copy {
  return COPY[useSettingsStore.getState().locale]
}
